import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ProcurementFile } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'

interface DropItemProps {
  file: ProcurementFile
}

const DropItem = ({ file }: DropItemProps) => {
  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="s64"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      gap="s8"
      cursor="pointer"
    >
      <Box flexDirection="row" gap="s12">
        <Box justifyContent="center">
          <DocumentType mimetype={file.contentType} />
        </Box>
        <Box justifyContent="center">
          <Box
            flexDirection="column"
            justifyContent="flexStart"
            alignItems="flexStart"
            gap="s4"
            maxWidth="s240"
          >
            <Text.Normal ellipsis weight="semibold" size="200">
              {file.filename}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
      <Box flexDirection="row" gap="s8">
        <Button.Router
          type="secondary"
          title={file.filename}
          to={file.url}
          rel="noopener noreferrer"
          download
          blankTarget
          iconName="download"
        />
      </Box>
    </Box>
  )
}

export default DropItem
